import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import TourStep from "./TourStep";
import "./Tour.css";

import Step1 from "../../assets/tour/step1.gif";
import Step2 from "../../assets/tour/step2.gif";
import Step3 from "../../assets/tour/step3.gif";
import Step4 from "../../assets/tour/step4.gif";

interface TourData {
  id: number;
  title: string;
  content: string;
  image?: string;
}

interface TourProps {
  isOpen: boolean;
  onClose: () => void;
}

const Tour: React.FC<TourProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [currentStep, setCurrentStep] = useState(0);
  const [isTourActive, setIsTourActive] = useState(isOpen);

  const instructionsTitle = t("ROOSTER.PUBLIC-APP.TOUR.INSTRUCTIONS_TITLE", {
    defaultValue: "Instructions to Provide Times"
  });

  const tourSteps: TourData[] = [
    {
      id: 1,
      title: instructionsTitle,
      content: t("ROOSTER.PUBLIC-APP.TOUR.STEP1_CONTENT", {
        defaultValue:
          "Select, drag and release to select your available times on the calendar"
      }),
      image: Step1
    },
    {
      id: 2,
      title: instructionsTitle,
      content: t("ROOSTER.PUBLIC-APP.TOUR.STEP2_CONTENT", {
        defaultValue: "Select a time then select the Remove button to delete it"
      }),
      image: Step2
    },
    {
      id: 3,
      title: instructionsTitle,
      content: t("ROOSTER.PUBLIC-APP.TOUR.STEP3_CONTENT", {
        defaultValue: "Drag the top or bottom of the time block to resize times"
      }),
      image: Step3
    },
    {
      id: 4,
      title: instructionsTitle,
      content: t("ROOSTER.PUBLIC-APP.TOUR.STEP4_CONTENT", {
        defaultValue: "Select at the top to be available for the entire day"
      }),
      image: Step4
    }
  ];

  useEffect(() => {
    setIsTourActive(isOpen);
    if (isOpen) {
      setCurrentStep(0);
    }
  }, [isOpen]);

  const handleNext = () => {
    if (currentStep < tourSteps.length - 1) {
      setCurrentStep(currentStep + 1);
    } else {
      handleClose();
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleClose = () => {
    setIsTourActive(false);
    onClose();
  };

  const handleSkip = () => {
    handleClose();
  };

  if (!isTourActive) {
    return null;
  }

  return (
    <div className="tour-overlay">
      <TourStep
        {...tourSteps[currentStep]}
        currentStep={currentStep + 1}
        totalSteps={tourSteps.length}
        onNext={handleNext}
        onPrev={handlePrev}
        onClose={handleClose}
        onSkip={handleSkip}
      />
    </div>
  );
};

export default Tour;
